import type { FormErrorEvent, FormErrorWithId } from 'ui/util/ui/import';

const getElement = (error: FormErrorWithId): HTMLElement | null => {
  if (error.id) {
    return document.getElementById(error.id);
  }
  if (error.name) {
    const elements = document.getElementsByName(error.name);
    return elements[0] ?? null;
  }
  return null;
};

export const onFormErrorFocus = (event: FormErrorEvent, scroll = false) => {
  const firstError = event.errors[0];
  if (firstError) {
    const element = getElement(firstError);
    if (element) {
      if (scroll) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      window.setTimeout(() => { element.focus(); }, 0);
    }
  }
};

export const onFormErrorScrollFocus = (event: FormErrorEvent) => onFormErrorFocus(event, true);
